<template>
  <div class="card">
    <div class="card-content">
      <div class="back-link">
        <router-link class="card-footer-item" to="/">Home Page</router-link>
      </div>
      <div class="content">
        <h2>THE MOST INTERESTING PLACES ON GOOGLE STREET VIEW</h2>
        <p style="padding-bottom: 15px;">
          In this section you can find screenshots of really <strong>interesting places on Google Street View with coordinates</strong> and detailed descriptions.
        </p>
        <div class="columns">
            <div class="gallery-point">
              <GalleryPoint
                v-bind:next_key = "next_key"
                v-bind:prev_key = "prev_key"
                v-bind:description = "point.description"
                v-bind:coordinates = "point.coordinates"
                v-bind:map_link = "point.map_link"
                v-bind:city="point.city"
                v-bind:region="point.region"
                v-bind:country="point.country"
                v-bind:image_url="point.image_url"
                v-bind:image_keys="point.image_keys"></GalleryPoint>
            </div>
        </div>
      </div>
    </div>
    <div id="main_adds"></div>
  </div>
</template>

<script>
import GalleryPoint from '@/components/GalleryPoint'
import myadds from '../assets/myads.html'
import postscribe from 'postscribe'

export default {
  name: 'Gallery',
  components: {GalleryPoint},
  data () {
    return {
      next_key: '',
      prev_key: '',
      point: {
        id: 1,
        key: '',
        image_url: '',
        image_keys: '',
        country: '',
        city: '',
        coordinates: '',
        map_link: '',
        description: ''
      },
      points: [
        {
          id: 1,
          key: 'nine_elms',
          image_url: 'https://firebasestorage.googleapis.com/v0/b/mapview-306310.appspot.com/o/london.png?alt=media&token=48c9183d-3cd3-4d5e-9f69-6c0c7f02b8b8',
          image_keys: 'UK, Great Britain, England, London, Battersea, Wandsworth, South West London, Nine Elms',
          country: 'UK',
          city: 'London',
          coordinates: '51.4815135, -0.1275459',
          map_link: 'https://www.google.com/maps/@51.4815135,-0.1275459,3a,82.2y,354.26h,104.91t/data=!3m6!1e1!3m4!1sSv4OovF1TJruZIYjT_KEnA!2e0!7i16384!8i8192',
          description: '<strong>Nine Elms</strong> is a busy area situated within <strong>Battersea</strong> in <strong>South West London</strong> and <strong>London Borough of Wandsworth</strong> alongside the <strong>River Thames</strong>. It is dominated by railway lines and high-rises but you also can see many narrow cozy streets with low-rise buildings there.'
        },
        {
          id: 2,
          key: 'uru_uru',
          image_url: 'https://firebasestorage.googleapis.com/v0/b/mapview-306310.appspot.com/o/caro.png?alt=media&token=61a1d0eb-f5be-4cd8-9957-508a7ff52728',
          image_keys: 'Bolivia, Oruro, Uru Uru, South America, Latin America, Altiplano, Andean Plateau, Andes',
          country: 'Bolivia',
          city: 'Oruro',
          map_link: 'https://www.google.com/maps/@-17.966481,-67.1114352,3a,82.2y,313.94h,98.03t/data=!3m6!1e1!3m4!1s3ZcePo6N-a__BRfC4IEisw!2e0!7i13312!8i6656',
          coordinates: '-17.966481, -67.1114352',
          description: '<strong>Oruro</strong> or <strong>Uru Uru</strong> is a <strong>Bolivian city</strong> situated in the <strong>Altiplano</strong> or <strong>Andean Plateau</strong>, 3,735 meters (12,254 ft) above the sea level. It is three hours by bus from <strong>La Paz</strong>. <strong>Oruro</strong> is known for its carnival, which takes every year and lasts 10 days. <strong>The Carnival of Oruro</strong> is on the <strong>UNESCO Representative List of the Intangible Cultural Heritage of Humanity.</strong>'
        },
        {
          id: 3,
          key: 'troms_og_finnmark',
          image_url: 'https://firebasestorage.googleapis.com/v0/b/mapview-306310.appspot.com/o/Screenshot%202021-04-05_11-29-52-516.png?alt=media&token=ae30ed67-b137-4a11-80ee-a83102fa355f',
          image_keys: 'Norway, Troms og Finnmark, Europe, Northern Europe, Scandinavia, nature, scenic, fjords',
          country: 'Norway',
          region: 'Troms og Finnmark',
          map_link: 'https://www.google.com/maps/@69.5247632,20.6974175,3a,75y,157.88h,87.53t/am=t/data=!3m6!1e1!3m4!1sWc6kH1POb2Kvi3q8_14Stg!2e0!7i16384!8i8192',
          coordinates: '69.5247632, 20.6974175',
          description: '<strong>Troms og Finnmark</strong> is a county in the far north of <strong>Norway</strong>. It is the largest territorial unit by area in the country - 75,000 square kilometers (29,000 square mi). This region is characterized by very beautiful <strong>Nordic</strong> nature with scenic landscapes of spectacular mountains, numerous islands, and long <strong>fjords.</strong>'
        },
        {
          id: 4,
          key: 'ganges_delta',
          image_url: 'https://firebasestorage.googleapis.com/v0/b/mapview-306310.appspot.com/o/bangladesh.png?alt=media&token=db249ac6-20b9-4f8a-9360-7da49bd14d49',
          image_keys: 'Bangladesh, Ganges delta, Barishal Division, Asia, South Asia, transportation, bus, dirt road',
          country: 'Bangladesh',
          region: 'Barishal Division',
          map_link: 'https://www.google.com/maps/@21.8923823,90.1390402,2a,75y,19.41h,89.97t/data=!3m6!1e1!3m4!1sAg6QTkY9tL2yQQoi5JyQcg!2e0!7i13312!8i6656',
          coordinates: '21.8923823,90.1390402',
          description: 'People sitting on top of a bus that is going on a dirt road in the part of <strong>Ganges Delta</strong>, the world\'s largest river delta that covers more than 105,000 square kilometers (41,000 square mi). Approximately 60% of the delta lies in <strong>Bangladesh</strong> and 40% in <strong>West Bengal, India.</strong>'
        },
        {
          id: 5,
          key: 'malabadi_bridge',
          image_url: 'https://firebasestorage.googleapis.com/v0/b/mapview-306310.appspot.com/o/Turkey.png?alt=media&token=ba28265c-14b3-4469-9db4-fbe926eb7470',
          image_keys: 'Turkey, Malabadi Bridge, Batman River, Diyarbakir Province, Eastern Anatolia Region, Asia, Middle East',
          country: 'Turkey',
          region: 'Diyarbakir Province, Eastern Anatolia Region',
          map_link: 'https://www.google.com/maps/@38.1535219,41.2032976,3a,82.2y,71.08h,84.28t/data=!3m6!1e1!3m4!1s90cpUjIJY-gQC4xZzQUmMA!2e0!7i13312!8i6656',
          coordinates: '38.1535219, 41.2032976',
          description: 'The <strong>Malabadi Bridge</strong> is the spanned stone arch bridge. Located on the <strong>Batman River</strong> near the small city of <strong>Silvan</strong> in <strong>Diyarbakir Province, Eastern Anatolia Region, Turkey</strong>. This bridge has been constructed in the 12th century. It is inscribed in the <strong>Tentative List of UNESCO World Heritage Sites in Turkey.</strong>'
        },
        {
          id: 6,
          key: 'reisa_river',
          image_url: 'https://firebasestorage.googleapis.com/v0/b/mapview-306310.appspot.com/o/Norway2.png?alt=media&token=d101472a-dfa4-4894-bd52-679a7343cd61',
          image_keys: 'Norway, Reisa River, Troms og Finnmark, Europe, Northern Europe, Scandinavia, nature, river',
          country: 'Norway',
          region: 'Troms og Finnmark',
          map_link: 'https://www.google.com/maps/@69.767606,21.0172714,3a,75y,98.88h,92.99t/am=t/data=!3m6!1e1!3m4!1svoWywr1uWzbBN-wq7IOLjw!2e0!7i16384!8i8192',
          coordinates: '69.767606, 21.0172714',
          description: 'The bridge on the <strong>Reisa River</strong> in the far northern part of <strong>Norway</strong>. This watercourse is surrounded by picturesque mountains and forested valley sides.'
        },
        {
          id: 7,
          key: 'lesotho',
          image_url: 'https://firebasestorage.googleapis.com/v0/b/mapview-306310.appspot.com/o/Lesotho.png?alt=media&token=f6da62b9-0c5d-48ee-b824-98b2a9c476a6',
          image_keys: 'Lesotho, Africa, Southern Africa, Berea, nature',
          country: 'Lesotho',
          region: 'Berea District',
          map_link: 'https://www.google.com/maps/@-29.2378549,27.8706426,3a,82.2y,28.53h,81.11t/data=!3m6!1e1!3m4!1sQv23viX6F-b9MuTQw8XV6Q!2e0!7i13312!8i6656',
          coordinates: '-29.2378549, 23.3969752,6',
          description: '<strong>Berea</strong> is one of the northern districts of <strong>Lesotho</strong>, a country in the <strong>Southern Africa.</strong>'
        },
        {
          id: 8,
          key: 'pigeonmasks',
          image_url: 'https://firebasestorage.googleapis.com/v0/b/mapview-306310.appspot.com/o/Japan.png?alt=media&token=68ba9046-f82f-41a6-9e97-46c7b3b5e3ed',
          image_keys: 'Japan, Tokyo, Asia, East Asia, flashmob, prank, pigeon mask, pigeon mask people, street',
          country: 'Japan',
          city: 'Tokyo',
          map_link: 'https://www.google.com/maps/@35.7040744,139.5577317,3a,80.9y,280.71h,67.52t/data=!3m6!1e1!3m4!1sgT28ssf0BB2LxZ63JNcL1w!2e0!7i13312!8i6656',
          coordinates: '35.7040744, 139.5577317',
          description: 'Eight people wearing <strong>pigeon masks</strong> looking at <strong>Google Street View</strong> camera in <strong>Tokyo, Japan.</strong> It looks like those guys knew about photographing this street for maps so probably they staged such a <strong>prank.</strong>'
        },
        {
          id: 9,
          key: 'senegal',
          image_url: 'https://firebasestorage.googleapis.com/v0/b/mapview-306310.appspot.com/o/senegal.png?alt=media&token=425b1635-0a97-480d-b40d-a5d5a27d8228',
          image_keys: 'Senegal, Dakar, Africa, West Africa',
          country: 'Senegal',
          city: 'Dakar',
          map_link: 'https://www.google.com/maps/@14.7119149,-17.453768,3a,82.2y,76.58h,95.79t/data=!3m6!1e1!3m4!1sBm_NTPd4vOYRY8GAzI6lhQ!2e0!7i13312!8i6656',
          coordinates: '14.7119149, -17.453768',
          description: 'Street of <strong>Dakar, Senegal</strong>’s capital and largest city. <strong>Dakar</strong> is situated in <strong>West Africa</strong>, on the <strong>Atlantic coast</strong>. It is the westernmost city on the <strong>African mainland.</strong>'
        },
        {
          id: 10,
          key: 'antirrio_bridge',
          image_url: 'https://firebasestorage.googleapis.com/v0/b/mapview-306310.appspot.com/o/rio.png?alt=media&token=eda63a16-151f-4abb-b28c-ded385ddcb10',
          image_keys: 'Greece, Rio Antirrio bridge, cable stayed bridge, Peloponnese, Gulf of Corinth',
          country: 'Greece',
          city: 'Rio',
          map_link: 'https://www.google.com/maps/@38.3095257,21.7793462,3a,82.2y,323.11h,101.54t/data=!3m6!1e1!3m4!1s37SI8jIKKShv-cPy5QgU2g!2e0!7i16384!8i8192',
          coordinates: '38.3095257, 21.7793462',
          description: '<p><strong>The Rio-Antirrio Bridge</strong> or the <strong>Charilaos Trikoupis Bridge </strong>is 2,880 meters (9,450 ft) multi-span cable-stayed bridge in <strong>Greece.</strong></p> <p>This construction crosses the <strong>Gulf of Corinth</strong>, linking the town of <strong>Rio</strong> on the <strong>Peloponnese</strong> peninsula with the town of <strong>Antirrio</strong> on the mainland part of the country.</> <p>The Rio-Antirrio is considered one of the longest bridges of such type in the world.</p> <p>It had been opened on August 12, 2004, just one day before the <strong>2004 Summer Olympics</strong> were started in <strong>Athens</strong>, the Greek capital.</p> <p>Now, drivers can both significantly shorten the way from and to Peloponnese and enjoy the spectacular view from the bridge.</p>'
        },
        {
          id: 11,
          key: 'lithuania',
          image_url: 'https://firebasestorage.googleapis.com/v0/b/mapview-306310.appspot.com/o/Lithuania.png?alt=media&token=85bd4720-d941-4949-9206-0c424eae8e73',
          image_keys: 'Lithuania, Republic of Lithuania, Belarus, Lithuanian Belarus border, Belarus Lithuanian border, Belarus Lithuania border, Lithuania Belarus border, border, Vilnius County',
          country: 'Lithuania',
          region: 'Vilnius County',
          map_link: 'https://www.google.com.ua/maps/@54.2749895,25.5632284,3a,75y,197.1h,78.15t/data=!3m6!1e1!3m4!1sIS_3JPrqvQORtVxl4_rnAQ!2e0!7i13312!8i6656',
          coordinates: '54.2749895, 25.5632284',
          description: '<p>The <strong>Belarus-Lithuania border</strong> is an international border between <strong>Belarus</strong> and <strong>Lithuania</strong>. Its length is approximately 679 km (422 mi).</p> <p>It was defined by the treaty of February 6, 1995, between the above-mentioned countries.</p> <p>In the picture, this frontier directly abuts the road in <strong>Vilnius County</strong> – you can see that the border fence is situated very close to the carriageway there</p>'
        }
      ]
    }
  },
  mounted () {
    this.point = this.points.find((p) => p.key === this.$route.params.name)
    const len = this.points.length
    let nextId = this.point.id + 1
    let prevId = this.point.id - 1
    if (nextId === len + 1) {
      nextId = 1
      prevId = len - 1
    }
    if (this.point.id === 1) {
      prevId = len
    }
    const nextPoint = this.points.find((p) => p.id === nextId)
    const prevPoint = this.points.find((p) => p.id === prevId)
    this.next_key = `/gallery/${nextPoint.key}`
    this.prev_key = `/gallery/${prevPoint.key}`

    postscribe('#main_adds', myadds)
  }
}
</script>
<style>
.gallery-point {
  margin-bottom: 50px;
}
.back-link{
  width: 108px;
  position: relative;
  top: -7px;
}
#main_adds {
  height: 100px;
  position: fixed;
  bottom: 0px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue